// Máscaras e validações de documentos + endereço (Brasil)
// -----------------------------------------------------

export function sanitizeDigits(v) {
  return (v || "").replace(/\D/g, "");
}

export function maskCPF(v) {
  const d = sanitizeDigits(v).slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function isValidCPF(cpf) {
  const d = sanitizeDigits(cpf);
  if (d.length !== 11) return false;
  if (/^(\d)\1+$/.test(d)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(d[i], 10) * (10 - i);
  let r = (sum * 10) % 11;
  if (r === 10) r = 0;
  if (r !== parseInt(d[9], 10)) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(d[i], 10) * (11 - i);
  r = (sum * 10) % 11;
  if (r === 10) r = 0;
  return r === parseInt(d[10], 10);
}

export function maskCEP(v) {
  const d = sanitizeDigits(v).slice(0, 8);
  return d.replace(/(\d{5})(\d)/, "$1-$2");
}

export function isValidCEP(cep) {
  return sanitizeDigits(cep).length === 8;
}

// ViaCEP → devolve { street, neighborhood, city, state } ou null em caso de erro
export async function fetchAddressByCEP(cep) {
  const d = sanitizeDigits(cep);
  if (d.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    if (!r.ok) return null;
    const j = await r.json();
    if (j?.erro) return null;
    return {
      street: j.logradouro || "",
      neighborhood: j.bairro || "",
      city: j.localidade || "",
      state: (j.uf || "").toUpperCase(),
      complement: j.complemento || "",
    };
  } catch {
    return null;
  }
}

// RG: aceita letras (X final), pontos e traços. Apenas normaliza.
export function maskRG(v) {
  return (v || "").toUpperCase().replace(/[^0-9A-Z.-]/g, "").slice(0, 15);
}

export const BR_STATES = [
  "AC","AL","AM","AP","BA","CE","DF","ES","GO","MA","MG","MS","MT","PA","PB",
  "PE","PI","PR","RJ","RN","RO","RR","RS","SC","SE","SP","TO",
];
